import { render, staticRenderFns } from "./bandPhone.vue?vue&type=template&id=261fde16&scoped=true"
import script from "./bandPhone.vue?vue&type=script&lang=js"
export * from "./bandPhone.vue?vue&type=script&lang=js"
import style0 from "./bandPhone.vue?vue&type=style&index=0&id=261fde16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261fde16",
  null
  
)

export default component.exports